































































import {
  createComponent,
  inject,
  onMounted,
  computed,
  reactive,
  ref,
  onUpdated
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import CompanyKey from "@/components/company-key";
import FormHeader from '../../molecules/FormHeader.vue'
import customValidator from "@/lib/customValidator.ts"
import RefleshIcon from "@/components/atoms/icon/RefleshIcon.vue";
export default createComponent({
  setup(_, { root }) {
    const state = reactive({
      message: ""
    })
    const displayui = inject(DisplayUIKey);
    if (!displayui) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const company = inject(CompanyKey);
    if (!company) {
      throw new Error(`${CompanyKey} is not provided`);
    }
    const chatForm = ref(null)
    const customerId = window.location.pathname.split('/')[4]
    const jobId = window.location.pathname.split('/')[6]
    const getUserChatInfor = company.getUserChatInfor
    onMounted(() => {
      getUserChatInfor(customerId,jobId)
      company.getAttendanceReason(customerId, jobId);
    });
    const sendChat = (() => {
      //@ts-ignore
      if(!chatForm.value.validate()){
        return;
      }
      company.sendChat(customerId, jobId, state.message) as any
      state.message = '';
    });

    const refreshChat = (() =>{
      getUserChatInfor(customerId,jobId)
      
    })

    onUpdated(() =>{
      root.$nextTick(() => {
        var objDiv = document.getElementById("divChatArea");
        if(objDiv){
          //@ts-ignore
          objDiv.scrollTop = objDiv.scrollHeight;
        }
      });
    })

    const userInfor = computed(() => company.userDetailInformation);
    const canSendChat = computed(() =>{
      if(company.userDetailInformation.attendanceReason){
        return false;
      }else{
        return true;
      }
    })
 
    return {
      userInfor,
      sendChat,
      state,
      canSendChat,
      chatForm,
      customValidator,
      refreshChat,
    };
  },
  components: {
    FormHeader,
    RefleshIcon
  }
})
